import React from 'react';
import { MdDoubleArrow } from 'react-icons/md';

export default class MoveForwardFaster extends React.Component {
    public render(): JSX.Element {
        return <MdDoubleArrow className='mff' />;
    }
}
